import chalk, { Options as ChalkOptions } from 'chalk';
import { PluginFunction } from './plugin';

type LocalConsoleFormatterOptions = Pick<ChalkOptions, 'level'>;

const LocalConsoleFormatter = ({ level }: LocalConsoleFormatterOptions): PluginFunction => {
  const c = level === undefined ? chalk : new chalk.Instance({ level });

  return ({ method, message, loggerName, methodName }) => {
    const { message: resolvedMessage, ...resolvedMeta } = typeof message == 'object' ? message : { message };

    // Convert the meta data to a key=value stringified output
    const keyValues = Object.keys(resolvedMeta)
      .map((key) => `${c.dim(key)}=${c.yellow(JSON.stringify(resolvedMeta[key] || ''))}`)
      .join(' ');

    // Render a log line in the format of:
    // [timestamp] LEVEL loggerName Message key=value
    const rendered = `[${resolvedMeta.timestamp || new Date().toISOString()}] ${methodName} ${c.grey(
      `${String(loggerName)}`
    )} ${c.blue(resolvedMessage || '')} ${keyValues}`;

    return method(rendered);
  };
};

const JSONStreamConsoleFormatter: PluginFunction = ({ method, message }) => {
  return method(JSON.stringify(message));
};

export { LocalConsoleFormatter, JSONStreamConsoleFormatter };
